import { Box, BoxProps } from "@chakra-ui/react";

export const SendIcon = (props: BoxProps) => (
    <Box {...props}>
        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21.0477 3.83052C18.8697 1.48495 2.48648 7.23078 2.50001 9.32859C2.51535 11.7075 8.89809 12.4393 10.6672 12.9356C11.7311 13.2341 12.016 13.54 12.2613 14.6557C13.3723 19.7081 13.9301 22.221 15.2014 22.2772C17.2278 22.3668 23.1733 6.11959 21.0477 3.83052Z" stroke="#5C6670" stroke-width="1.5" />
            <path d="M11.5 13.2776L15 9.77759" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    </Box>
);
